export const getExtraProfileDataFromCustomAttributes = (
  customAttr?: Record<string, unknown>
): Record<string, string> => {
  if (!customAttr) return {};

  const keys = Object.keys(customAttr);
  const extra: Record<string, string> = {};

  keys.forEach((key) => {
    if (typeof customAttr[key] === "string") {
      extra[key] = customAttr[key] as string;
    } else {
      extra[key] = JSON.stringify(customAttr[key]);
    }
  });

  return extra;
};
